/**
 * Meta Pixel (Facebook / Instagram Ads).
 * ID del pixel de VCARS — editalo acá si cambia.
 */
export const META_PIXEL_ID = '2137826673813226'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

let initialized = false

/** Carga el pixel una sola vez y registra el PageView. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Dispara un evento estándar del pixel (ej. "Contact", "Lead"). */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}
